import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../../lib/api";

export const useLifePublic = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/public/life").then(({ data }) => setD(data)).catch(() => {}); }, []);
  return d;
};

export const LifeThemes = ({ themes = [], showStories = false }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 font-round" data-testid="life-themes-showcase">
    {themes.map((t, i) => (
      <motion.div key={t.theme_id} data-testid={`public-theme-${t.theme_id}`} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.06 }}
        className="rounded-3xl overflow-hidden bg-white border-2" style={{ borderColor: `${t.color}66` }}>
        <div className="relative h-24">
          <img src={t.background} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 flex items-center gap-2 px-4 text-white" style={{ background: `linear-gradient(90deg, ${t.color}ee, ${t.color}55)` }}>
            <span className="text-4xl">{t.emoji}</span><span className="text-2xl">{t.name}</span>
          </div>
        </div>
        {showStories && (
          <ul className="p-4 space-y-1 text-lg text-stone-700">
            {t.stories.map((s) => <li key={s.story_id} className="flex items-center gap-2"><span>{s.sticker}</span>{s.story_title}</li>)}
          </ul>
        )}
      </motion.div>
    ))}
  </div>
);
